import DataTable from "../../../Components/DataTable/DataTable";
import {
  ExclamationCircleFilled,
  ExclamationOutlined,
  StarOutlined,
  WarningFilled,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Button, Modal, Select, Tag } from "antd";
import styles from "./Skills.module.css";
import Ways from "../Ways/Ways";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/action";
import api from "../../../api/api";
import { dataFetchError, editError } from "../../../Util/Messages";

// import WayMapper from "../../../Util/WayMapper";
import CheckPermission from "../../../Util/CheckPermission";
import { useNavigate } from "react-router-dom";
import WayMapper from "../../../Util/WayMapper";
import ExportExcel from "../../../Util/ExportExcel";
import { toJalaali } from "jalaali-js";
import { Tooltip } from "@mui/material";

const WayItem = ({ type, children }) => {
  return (
    <Tag style={{ margin: "0.25rem" }}>
      <div
        className={styles.WayItem}
        style={{
          wordBreak: "break-all",
          maxWidth: "7rem",
          overflow: "hidden",
          overflowWrap: "break-word",
        }}
      >
        {WayMapper[type] && (
          <div className={styles.WayItemHeader}>
            {WayMapper[type].icon} <b>{WayMapper[type].title}</b>
          </div>
        )}
        <Tooltip title={<div>{children}</div>}>
          <div>{children}</div>
        </Tooltip>
      </div>
    </Tag>
  );
};

const Skills = ({
  rowSelection,
  LoadingSetter,
  loading,
  ClearLoading,
  ClearError,
  ErrorSetter,
  permissions,
  skillsData,
  loadAll = false,
  role,
  // loadData,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [editingRecord, setEditingRecord] = useState();
  const [editableKeys, setEditableRowKeys] = useState();
  const [pagination, setPagination] = useState({});
  const [data, setData] = useState();
  const [skillsTag, setSkillsTag] = useState([]);
  const navigate = useNavigate();

  const getSkillsTag = () => {
    api
      .get("/skills/tags")
      .then((res) =>
        setSkillsTag(res?.data?.filter((e) => e && e?.trim() !== "") ?? [])
      )
      .catch(() => {});
  };

  const Types = [
    { value: "skill", text: "مهارت" },
    { value: "knowledge", text: "دانش" },
    { value: "none", text: "ندارد" },
  ];

  const columns = [
    {
      title: "عنوان",
      dataIndex: "type",
      filters: Types,
      onFilter: (value, record) => {
        if (record.type) {
          return record.type.includes(value);
        } else {
          return true;
        }
      },
      width: "8%",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select>
              {Types.map((el) => {
                return (
                  <Select.Option value={el.value} key={el.value}>
                    {el.text}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (text, row) => <div>{TypeMapper(text)}</div>,
    },
    {
      title: "نام مهارت",
      dataIndex: "title",
      searchable: true,
      width: "25%",
    },
    {
      title: "تگ",
      dataIndex: "tags",
      filters: (skillsTag ?? [])?.map((el) => ({ value: el, text: el })),
      onFilter: (value, record) => record?.tags?.includes(value),
      renderFormItem: (_, { isEditable, record }) => {
        if (!isEditable) return;
        return (
          <Select
            mode="tags"
            allowClear
            style={{ width: "100%" }}
            placeholder="تگ"
          >
            {(skillsTag ?? [])?.map((tag) => (
              <Select.Option key={tag} value={tag}>
                {tag}
              </Select.Option>
            ))}
          </Select>
        );
      },
      render: (tempTags, row) => {
        const recordTags = Array.isArray(tempTags) ? tempTags : [];
        if (recordTags.length === 0) return "-";

        return recordTags.map((el) => (
          <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
        ));
      },
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      searchable: true,
      width: "25%",
    },
    {
      title: "‌کارت‌های متصل",
      dataIndex: "flags",
      filterMultiple: false,
      // searchable : true,
      filters: [
        {
          value: "has_flag",
          text: "کارت دار",
        },
        {
          value: "no_flag",
          text: "بدون کارت",
        },
      ],
      onFilter: (value, record) => {
        let hasFlag = true;
        if (Array.isArray(record.flags)) {
          if (record.flags.length === 0) {
            hasFlag = false;
          }
        }
        switch (value) {
          case "has_flag":
            return hasFlag;
          case "no_flag":
            return !hasFlag;
          default:
            return hasFlag;
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              {Array.isArray(record.flags)
                ? record.flags.map((el) => (
                    <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
                  ))
                : null}
            </div>
          );
        }
      },
      render: (flags, row) => {
        // console.log(ways , 'ways')
        if (Array.isArray(flags)) {
          if (flags.length === 0) {
            return (
              <div>
                <WarningFilled /> مهارت به کارتی متصل نیست!
              </div>
            );
          }
          return flags.map((el) => (
            <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
          ));
        }
      },
    },
    {
      title: "روش‌های یادگیری",
      dataIndex: "ways",
      filterMultiple: false,
      // searchable : true,
      filters: [
        {
          value: "has",
          text: "روش یادگیری دار",
        },
        {
          value: "no",
          text: "بدون روش یادگیری",
        },
      ],
      onFilter: (value, record) => {
        let hasWay = true;
        if (Array.isArray(record.ways)) {
          if (record.ways.length === 0) {
            hasWay = false;
          }
        }
        switch (value) {
          case "has":
            return hasWay;
          case "no":
            return !hasWay;
          default:
            return hasWay;
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              {Array.isArray(record.ways)
                ? record.ways.map((el) => (
                    <WayItem type={el.type}>{el.title}</WayItem>
                  ))
                : null}
              <Button
                onClick={() => {
                  setOpenModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>
            </div>
          );
        }
      },
      render: (ways, row) => {
        // console.log(ways , 'ways')
        if (Array.isArray(ways)) {
          if (ways.length === 0) {
            return (
              <div>
                <ExclamationCircleFilled /> مهارت بدون روش یادگیری است.
              </div>
            );
          }
          return ways.map((el) => <WayItem type={el.type}>{el.title}</WayItem>);
        }
      },
    },
    {
      title: "تاریخ ساخت ",
      width: "8%",
      align: "center",
      dataIndex: "createdAt",
      editable: false,
      // sorter: (a, b) => {
      //   const Adate = new Date(a.createdAt);
      //   const Bdate = new Date(b.createdAt);

      //   return Bdate - Adate;
      // },
      render: (text, record) => {
        const date = text ? new Date(text) : new Date();
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
  ];

  const loadData = (page = 1, pageSize = 100, filters = {}) => {
    api
      .get("/skills", {
        params: {
          page: loadAll ? 1 : page,
          pageSize: loadAll ? 9999 : pageSize,
          filters,
        },
      })
      .then((res) => {
        setData(res.data.data);
        setPagination(res.data.pagination);
      });
  };

  const filtersBeautify = (fData) => {
    return {
      ...(fData.title?.at(0) ? { title: fData.title?.at(0) } : {}),
      ...(fData.tags?.at(0) ? { tag: fData.tags } : {}),
      ...(fData.type?.at(0) ? { type: fData.type } : {}),
      ...(fData.flags?.at(0)
        ? { haveFlagsCheck: fData.flags?.at(0) === "has_flag" }
        : {}),
      ...(fData.ways?.at(0)
        ? { haveWaysCheck: fData.ways?.at(0) === "has" }
        : {}),
      ...(fData.description?.at(0)
        ? { description: fData.description?.at(0) }
        : {}),
    };
  };

  const TypeMapper = (type) => {
    let text = null;
    Types.forEach((e) => {
      if (e.value === type) {
        text = e.text;
      }
    });
    return text;
  };

  const removeWayHandler = (record) => {
    const newData = data;
    const newRecord = editingRecord;
    const ways = newRecord.ways;
    let index = null;
    ways.forEach((way, i) => {
      if (way.id === record.id) {
        index = i;
      }
    });
    newRecord.ways.splice(index, 1);
    const finalData = newData.map((el) => {
      if (el.id === newRecord.id) {
        return newRecord;
      }
      return el;
    });
    setData(finalData);
  };

  const onSelectWayHandler = (record, selected) => {
    if (selected) {
      const newData = data;
      const newRecord = editingRecord;
      newRecord.ways.push(record);
      const finalData = newData.map((el) => {
        if (el.id === newRecord.id) {
          return newRecord;
        }
        return el;
      });
      setData(finalData);
    } else {
      removeWayHandler(record);
    }
  };

  const onSave = (row, rowData) => {
    let oldData = null;
    [...data].forEach((item) => {
      if (item.id === row.id) {
        oldData = item;
      }
    });
    if (oldData === null) {
      LoadingSetter();
      api
        .post("/skills", {
          data: {
            type: rowData.type,
            title: rowData.title,
            tags: rowData.tags ?? [],
            description: rowData.description ? rowData.description : "-",
          },
        })
        .then((res) => {
          if (Array.isArray(rowData.ways)) {
            [...rowData.ways].forEach((val, index) => {
              const isLastReq = [...rowData.ways].length === index + 1;
              api
                .post("/relations/skilltoway", {
                  data: { skillId: res.data.id, wayId: val.id },
                })
                .then(() => {
                  if (isLastReq) {
                    ClearLoading();
                    loadData();
                  }
                })
                .catch(() => {
                  if (isLastReq) {
                    ClearLoading();
                    loadData();
                  }
                });
            });
          } else {
            ClearLoading();
            loadData();
          }
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
      setTimeout(() => {
        ClearLoading();
      }, 3000);
    } else {
      LoadingSetter();
      api
        .put("/skills/" + oldData.id, {
          data: {
            type: rowData.type,
            title: rowData.title,
            tags: rowData.tags ?? [],
            description: rowData.description ? rowData.description : "-",
          },
        })
        .then((res) => {
          // console.log(res.data)
          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
      api
        .get(`/skills/${oldData.id}`)
        .then((res) => {
          ClearLoading();
          const fetchedOldData = res.data;
          if (Array.isArray(rowData.ways)) {
            const removes = fetchedOldData.ways.map((el) => {
              let removed = true;
              // console.log(el)
              rowData.ways.forEach((a) => {
                if (el.id === a.id) {
                  removed = false;
                }
              });
              return removed ? el : null;
            });
            const adds = rowData.ways.map((el) => {
              let added = true;
              // console.log(el)
              fetchedOldData.ways.forEach((a) => {
                if (el.id === a.id) {
                  added = false;
                }
              });
              return added ? el : null;
            });
            if (Array.isArray(removes)) {
              removes.forEach((removed, index) => {
                if (removed) {
                  api
                    .post("/relations/removeskilltoway", {
                      data: { skillId: fetchedOldData.id, wayId: removed.id },
                    })
                    .then(() => {
                      if (index === removes.length - 1) {
                        ClearLoading();
                      }
                    })
                    .catch(() => {
                      if (index === removes.length - 1) {
                        editError();
                        ClearLoading();
                      }
                    });
                }
              });
            }
            if (Array.isArray(adds)) {
              adds.forEach((add, index) => {
                if (add) {
                  api
                    .post("/relations/skilltoway", {
                      data: { skillId: fetchedOldData.id, wayId: add.id },
                    })
                    .then(() => {
                      if (index === removes.length - 1) {
                        ClearLoading();
                      }
                    })
                    .catch(() => {
                      if (index === removes.length - 1) {
                        ClearLoading();
                        editError();
                      }
                    });
                }
              });
            }
          }
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    }
    // console.log(oldData , 'new data status')
  };

  const exportData = () => {
    const json = skillsData.map((skill) => {
      const skillObj = {
        نوع: TypeMapper(skill.type),
        "نام مهارت": skill.title,
        توضیحات: skill.description,
      };
      skill.ways.forEach((way, index) => {
        skillObj[`روش یادگیری ${index + 1}`] = way.title;
      });
      skill.flags.forEach((flag, index) => {
        skillObj[`کارت متصل${index + 1}`] = flag.title;
      });

      return skillObj;
    });
    ExportExcel(json, "مهارت‌ها");
  };

  useEffect(() => {
    if (!skillsData) {
      loadData();
    }
    if (skillsData) {
      setData(skillsData);
    }
  }, [skillsData]);

  useEffect(() => {
    getSkillsTag();
  }, []);

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("skills_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
  }, [permissions]);

  return (
    <div>
      <DataTable
        dynamicPagination
        recordsCount={pagination?.total}
        filtersBeautify={filtersBeautify}
        header={{
          title: "مهارت‌ها",
          avatar: { icon: <StarOutlined />, size: "large" },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
        editable
        keepPageOnSave
        columns={columns}
        dataSource={data}
        path="/skills"
        setDataSource={setData}
        rowClassName={(record) => {
          if (Array.isArray(record.ways) && record.ways.length === 0) {
            return "row_error";
          } else if (Array.isArray(record.flags) && record.flags.length === 0) {
            return "row_warning";
          }
        }}
        editableKeys={editableKeys}
        setEditableRowKeys={setEditableRowKeys}
        rowSelection={rowSelection}
        reload={loadData}
        onSave={onSave}
        recordDefault={{
          name: "",
          ways: [],
          flags: [],
          createdAt: new Date().toString(),
        }}
        permissionsPrefix="ways"
        userRole={role}
        showSupervisorFilter={true}
      />
      <Modal
        destroyOnClose
        centered
        width="100%"
        open={openModal}
        onOk={() => {
          setOpenModal(false);
        }}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Ways
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectWayHandler,
            selectedRowKeys: editingRecord
              ? editingRecord.ways.map((way) => way.id)
              : null,
          }}
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    skillsData: state.skills,
    role: state.userData ? state.userData.role : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    loadData: () =>
      dispatch(
        actions.getDatabase(null, { page: 1, pageSize: 100, filters: {} })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Skills);
